import * as service from './service'
export default {
  namespace: 'enrollEquipment',
  state: {
    receivingData: {}
  },
  effects: {
    * getReceiving ({ payload }, { call, put }) {
      const res = yield call(service.getReceiving, payload)
      yield put({
        type: 'save',
        payload: {
          receivingData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
